import { makeUseAxios } from "axios-hooks";

import { Config } from "@/utils/config.utils";

import { createApiFor, ExtendedUseAxios } from "./utils";

const useCustomerServiceApi = makeUseAxios({
    axios: createApiFor(`/customerservice/${Config.general.basestore}`),
    defaultOptions: {
        ssr: false,
        manual: false
    }
}) as ExtendedUseAxios;

export { useCustomerServiceApi };
